import { useEffect } from 'react';
import { Routes, Route, Navigate, useSearchParams, useLocation } from 'react-router-dom';
import { BasePath } from '../config/constants';
import useReferralState from '../context/referral/useReferralState';
import { getReferralById } from '../helpers';
import useIsMounted from '../hooks/useIsMounted';
import Analytics from '../pages/Analytics';
import Home from '../pages/Home';
import Leaderboard from '../pages/Leaderboard';
import Pools from '../pages/Pools';
import Referrals from '../pages/Referrals';
import Trade from '../pages/Trade';

const AppRoutes = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const isMounted = useIsMounted();

    const { setReferral } = useReferralState();

    const refID = searchParams.get('refCode');

    useEffect(() => {
        if (refID) {
            (async () => {
                const referral = await getReferralById(refID);

                if (referral.status === 404) return;

                localStorage.setItem('referral', JSON.stringify(referral.data));
                isMounted() && setReferral(referral.data);
            })();
        }
    }, [refID, setReferral, isMounted]);

    if (refID) {
        return <Navigate to={location.pathname} replace />;
    }

    return (
        <Routes>
            <Route path={BasePath.HOME} element={<Home />} />
            <Route path={BasePath.TRADE} element={<Trade />} />
            <Route path={`${BasePath.TRADE}/:chartSymbol`} element={<Trade />} />
            <Route path={BasePath.POOLS} element={<Pools />} />
            <Route path={BasePath.REFERRALS} element={<Referrals />} />
            <Route path={BasePath.ANALYTICS} element={<Analytics />} />
            <Route path={BasePath.LEADERBOARD} element={<Leaderboard />} />
            <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
    );
};

export default AppRoutes;
